import _ from 'lodash';
import { useRouter } from 'next/compat/router';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { MenuSortOptions, CategoriesWithPotencies, CategoriesWithTerpenes } from 'shared/constants';
import { useAllowSortByRelevance } from 'src/personalization/utils/hooks';
import useMenuFilterOptions from './use-menu-filter-options';
import { useDispensaryCategory } from './use-dispensary-category';

export default function useMenuSortOptions() {
  const category = useDispensaryCategory();
  const router = useRouter();
  const { brands } = useMenuFilterOptions();
  const allowSortByRelevance = useAllowSortByRelevance();
  const flags = useFlags();
  const featuredMenuSortOptionEnabled = flags['growth.ecomm.default-as-featured-menu-sort-option.rollout'] ?? false;
  const isMenuV2Enabled = flags['ecomm.admin.menu-v2.rollout'] ?? false;
  const terpenesSortEnabled = flags['ecomm.menu.total-terpenes-sort'] ?? false;

  const onBrandsPage = _.includes(router?.route, 'brands');
  const onSpecialsPage = _.includes(router?.route, 'specials');
  const onSearchResultsPage = category?.key === 'all';
  const hideRelevance = onBrandsPage || onSpecialsPage || onSearchResultsPage || !category?.key;
  const dontShowPotencies =
    !_.includes(CategoriesWithPotencies, category?.key) && !onBrandsPage && !onSpecialsPage && !onSearchResultsPage;
  const dontShowTerpenes =
    !terpenesSortEnabled ||
    (!_.includes(CategoriesWithTerpenes, category?.key) && !onBrandsPage && !onSpecialsPage && !onSearchResultsPage);
  const dontShowBrands = onBrandsPage || _.isEmpty(brands);

  let menuSortOptions = [...MenuSortOptions];

  if (dontShowBrands) {
    menuSortOptions = _.filter(menuSortOptions, ({ key }) => key !== 'brand');
  }

  if (dontShowPotencies) {
    menuSortOptions = _.filter(menuSortOptions, ({ key }) => key !== 'potencyhightolow' && key !== 'potencylowtohigh');
  }

  if (dontShowTerpenes) {
    menuSortOptions = _.filter(menuSortOptions, ({ key }) => key !== 'terpeneshightolow');
  }

  if (hideRelevance || !allowSortByRelevance) {
    menuSortOptions = _.filter(menuSortOptions, ({ key }) => key !== 'relevance');
  }

  if (!featuredMenuSortOptionEnabled || isMenuV2Enabled) {
    menuSortOptions = _.filter(menuSortOptions, ({ key }) => key !== 'default');
  }

  if (isMenuV2Enabled) {
    menuSortOptions = [
      {
        key: 'featuredProducts',
        label: 'Featured',
        allowSponsored: true,
      },
      ...menuSortOptions,
    ];
  }

  return menuSortOptions;
}
